<template lang="">
      <div class="app-create-new-ai-content__section">
        <div class="app-create-new-ai-content__section-header">
          <h4 class="app-create-new-ai-content__section-title">Basic details</h4>
          <p class="app-create-new-ai-content__section-instructions">Let us know what you're trying to build.</p>

          <app-error
            v-if="hasErrors"
            class="is--inline"
            v-bind="{ errors, message: errorMessage }" />
        </div>

        <form autocomplete="off" ref="inputFormBasicInfo">
          <div class="app-create-new-ai-content__section-body grid">
            <div class="col-12">
              <div class="input text">
                <label for="name">Title (required)</label>
                <input type="text" class="form-control" name="name" id="name" v-model="videoScriptData.name" required>
              </div>
            </div>
            <div class="col-12">
              <div class="input text">
                <label for="name">Description</label>
                <textarea rows="8" class="form-control" name="input_description" id="input_description" v-model="videoScriptData.ai_preferences.input_description"></textarea>
              </div>
            </div>
            <div class="col-12">
              <div class="input text">
                <label for="name">Duration</label>
                <input type="text" class="form-control" name="input_duration" id="input_duration" v-model="videoScriptData.ai_preferences.input_duration" placeholder="3 minutes, 30 seconds">
                <p class="inline-message">Please note that this is an approximation, and the AI-generated script may not perfectly match the specified duration.</p>
              </div>
            </div>
            <div class="col-12">
              <div class="input text">
                <label for="name">Video Structure</label>
                <textarea rows="8" class="form-control" name="input_structure" id="input_structure" v-model="videoScriptData.ai_preferences.input_structure" placeholder="Instructions on how the script should be structured, such as requests for on screen text"></textarea>
              </div>
            </div>
          </div>
          <div class="app-create-new-ai-content__section-footer">
            <app-button theme="primary" type="submit" class="" :disabled="disabledButton"
             @click="submitVideoScriptBasicData()">
              {{ disabledButton ? 'Processing...' : 'Next: Select Your Golden Source' }}
            </app-button>
          </div>
        </form>
      </div>
</template>

<script>
export default {
  name: 'VideoScriptAppBasicDetails',
  props: {
    videoScript: {
      type: Object,
      required: true
    },
    saveTrigger: {
      type: Boolean,
      required: false,
      default: false
    },
    subScreen: {
      type: String,
      required: true
    },
    disabledButton: {
      type: Boolean,
      required: false,
      default: false
    },
    hasErrors: {
      type: Boolean,
      required: false,
      default: false
    },
    errorMessage: {
      type: String,
      required: false,
      default: ''
    },
    errors: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      videoScriptData: this.videoScript ?? null
    }
  },
  methods: {
    submitVideoScriptBasicData(menuSwap = null) {
      const formData = new FormData(this.$refs.inputFormBasicInfo)
      const params = Object.fromEntries(formData.entries());
      this.$emit('submissionOfData', {videoScript: this.videoScriptData, params: params, subScreen: 'topics', menuSwap, entries: params });
    }
  },
  watch: {
    saveTrigger(newVal) {
      if (newVal) {
        this.submitVideoScriptBasicData('menuSwap');
      }
    }
  }
    
}
</script>
